const creditsNL = {
    "view": {
        "form": {
            "title": "Credits Bestellen",
            "label": {
                "quantity": "Aantal"
            },
            "placeholder": {
                "quantity": "Selecteer Aantal"
            },
            "help_text": {
                "quantity": "Aantal credits dat je wilt bestellen."
            },
            "button": {
                "placeOrder": "Bestelling Plaatsen"
            },
            "options": {
                "quantity": {
                    "selectQuantity": "Selecteer Aantal",
                    "1Credit": "1 Credit",
                    "2Credits": "2 Credits",
                    "3Credits": "3 Credits",
                    "4Credits": "4 Credits",
                    "5Credits": "5 Credits",
                    "10Credits": "10 Credits",
                    "15Credits": "15 Credits",
                    "20Credits": "20 Credits",
                    "25Credits": "25 Credits",
                    "30Credits": "30 Credits",
                    "35Credits": "35 Credits",
                    "40Credits": "40 Credits",
                    "45Credits": "45 Credits",
                    "50Credits": "50 Credits",
                    "75Credits": "75 Credits",
                    "100Credits": "100 Credits"
                }
            },
            "message": {
                "quantityRequired": "Aantal is verplicht",
                "paymentMethodRequired": "Voeg een <1>betaalmethode</1> toe om credits te bestellen.",
                "paymentMethodExpired": "Je kunt geen credits bestellen omdat je standaard <1>betaalmethode</1> is verlopen, stel een geldige betaalmethode in als standaard om credits te bestellen."
            }
        },
        "modal": {
            "header": "Ga door naar afrekenen",
            "body": {
                "message": "Je hebt {{credits}} Credits besteld",
                "confirmationMessage": "Als je de bestelling wilt bevestigen, ga dan door naar afrekenen, anders kun je de bestelling annuleren."
            },
            "button": {
                "cancel": "Annuleren",
                "checkout": "Afrekenen"
            }
        },
        "message": {
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transactie Succesvol :)",
            "description": "Je hebt succesvol de credits gekocht die binnenkort aan je account worden toegevoegd!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transactie Geannuleerd :(",
            "description": "De transactie is geannuleerd... Probeer het later opnieuw!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    }
};

export default creditsNL;